import React, { useMemo, useCallback } from 'react';
import AdbFlatTableBase, { AdbServiceParams } from './AdbFlatTableBase';
import { fetchClusterDetails } from 'service/service';
import {
  getClusterDetailsColumns,
  CLUSTER_DETAILS_DEFAULT_COLUMNS,
  CLUSTER_COMPUTE_TYPE_OPTIONS,
  QueryRule
} from 'utils/adb-common-util';

const PRESERVE_FILTER_KEY = 'top_ten_cluster_cost_interactive_table';

/**
 * TopTenClusterCostInteractive component refactored to use AdbFlatTableBase.
 * Reduces duplication to 0% by leveraging the base component.
 */
const TopTenClusterCostInteractive: React.FC = () => {
  const serviceFunc = useCallback(async (params: AdbServiceParams) => {
    const {
      startDate, endDate, env, sector, location,
      page, pageSize, apiFilters, exportType,
      sortBy, sortDir
    } = params;
    const findFilter = (field: string) => apiFilters.find(f => f.field === field)?.value;

    const computeType = findFilter('Compute Type') || 'INTERACTIVE';
    const workspace = findFilter('Workspace Name') || 'all';
    const clusterName = findFilter('Cluster Name') || 'all';

    return fetchClusterDetails({
      startDate,
      endDate,
      sector,
      env,
      computeType: String(computeType),
      location,
      autoTermination: undefined,
      workspaceID: String(workspace),
      jobName: undefined,
      clusterName: String(clusterName),
      page,
      pageSize,
      sortField: sortBy,
      sortOrder: sortDir,
      exportType
    });
  }, []);

  const initialFilters: QueryRule[] = useMemo(() => [
    { id: '1', operator: 'AND', field: 'Compute Type', value: 'INTERACTIVE' },
    { id: '2', operator: 'AND', field: 'Workspace Name', value: 'all' },
    { id: '3', operator: 'AND', field: 'Cluster Name', value: 'all' }
  ], []);

  const environmentOptions = useMemo(() =>
    CLUSTER_COMPUTE_TYPE_OPTIONS.filter(opt => opt.value !== 'SQL'),
    []
  );

  return (
    <AdbFlatTableBase
      serviceFunc={serviceFunc}
      pageTitle="Top 10 Cluster Cost by Compute - Interactive Details"
      breadcrumbLabel="Cluster Analytics"
      breadcrumbPath="/databricksADB/clusteranalytics"
      tableType="top-ten-cluster-cost-interactive"
      defaultColumnNames={CLUSTER_DETAILS_DEFAULT_COLUMNS}
      getColumns={getClusterDetailsColumns}
      preserveFilterKey={PRESERVE_FILTER_KEY}
      initialComputeType="INTERACTIVE"
      initialFilters={initialFilters}
      environmentOptions={environmentOptions}
      showClusterName={true}
    />
  );
};

export default TopTenClusterCostInteractive;